<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTipoResultado"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ emptyLabel }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'conf_jsonSelected', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'tipo_resultado', null);
        return;
      }
      this.$emit('selectChange', 'tipo_resultado', e);
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', selectedActual);
    },
    setOptions(conf_jsonSelected) {
      const conf = JSON.parse(conf_jsonSelected);
      if (conf && Object.keys(conf).length > 0) {
        this.isLoading = true;
        const parser = conf.resultadosAceitos.map((tipo_resultado) => ({
          id: tipo_resultado.idTipoResultado,
          nome: tipo_resultado.nome
        }));
        this.options = parser;
        this.setValue(this.nameField);
        this.isLoading = false;
      } else {
        this.options = [];
        this.selected = null;
      }
    },
    labelTipoResultado({ nome }) {
      return `${nome}`;
    }
  },

  watch: {
    conf_jsonSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    if (this.conf_jsonSelected) this.setOptions(this.conf_jsonSelected);
  }
};
</script>

<style lang="scss" scoped></style>
